'use client';

import { useInView } from 'react-intersection-observer';
import { TrustBox } from '~/components/Trustpilot';
import styles from './TripOverviewCommunityHighlights.module.css';

export const TripOverviewReviewsInView = () => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '400px' });

  return (
    <div ref={ref} className={styles.widgetSlot}>
      {inView ? <TrustBox templateId="53aa8912dec7e10d38f59f36" /> : null}
    </div>
  );
};
